const state = {
  isOpen: false,
};

const mutations = {
  toggle(state, newState) {
    state.isOpen = newState;
  },
};

const actions = {
  open({ commit }) {
    commit('toggle', true);
    document.body.classList.add('has-manifest');
  },

  close({ commit }) {
    commit('toggle', false);
    document.body.classList.remove('has-manifest');
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
